import { FC } from 'react';

interface INameCellProps {
  name?: string;
}
export const NameCell: FC<INameCellProps> = ({ name }) => {
  return (
    <span className="text-lg font-medium leading-[18px] text-[rgba(31,43,64,1)]">
      {name}
    </span>
  );
};
